import type { ButtonHTMLAttributes, ReactNode } from 'react';
import type { Icon as PhosphorIcon } from '@phosphor-icons/react';
import { cx } from '../../lib/cx';
import { Icon } from '../Icon';

/** The look of the Home CTA, for a link that should read as the button. */
export const homeCtaClassName = cx(
  'inline-flex h-(--mbm-size-button-hero) w-full items-center justify-center gap-(--mbm-space-2) rounded-(--mbm-component-radius-button)',
  'bg-(image:--mbm-gradient-cta-primary) text-label-large text-text-on-dark shadow-(--mbm-shadow-glow-blue)',
  'transition-opacity duration-(--mbm-duration-fast) hover:opacity-(--mbm-opacity-pressed)',
  'focus-visible:outline-none focus-visible:shadow-(--mbm-shadow-focus-ring)',
);

/** Figma "Home CTA": a full-width blue-to-indigo pill with a blue glow. */
export function HomeCtaButton({
  icon,
  children,
  className,
  type = 'button',
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { icon?: PhosphorIcon; children: ReactNode }) {
  return (
    <button type={type} className={cx(homeCtaClassName, className)} {...props}>
      {icon ? <Icon icon={icon} size="md" /> : null}
      {children}
    </button>
  );
}
